(function() {
    'use strict';

    /**
     * Bootstrap Select Dropup Scroll Fix
     * Prevents dropdown from expanding to window height when scrolling in dropup mode
     */

    // Wait for document ready
    angular.element(document).ready(function() {

        // Store original max-height when dropdown opens
        var dropupHeights = new WeakMap();

        // Override the scroll handler for dropup selects
        angular.element(window).on('scroll.bs-select-dropup-fix', function() {
            angular.element('.bootstrap-select.dropup.open').each(function() {
                var $select = angular.element(this);
                var $menu = $select.find('.dropdown-menu');

                // Store original height on first scroll
                if (!dropupHeights.has($menu[0])) {
                    var currentHeight = $menu.css('max-height');
                    if (currentHeight && currentHeight !== 'none') {
                        dropupHeights.set($menu[0], currentHeight);
                    }
                }

                // Reapply stored height to prevent expansion
                var storedHeight = dropupHeights.get($menu[0]);
                if (storedHeight) {
                    $menu.css({
                        'max-height': storedHeight,
                        'overflow-y': 'auto',
                        'position': 'absolute',
                        'bottom': '100%',
                        'top': 'auto'
                    });
                }
            });
        });

        // Clean up stored heights when dropdown closes
        angular.element(document).on('hidden.bs.dropdown', '.bootstrap-select.dropup', function() {
            var $menu = angular.element(this).find('.dropdown-menu');
            if ($menu[0] && dropupHeights.has($menu[0])) {
                dropupHeights.delete($menu[0]);
            }
        });

        // Prevent resize on scroll for dropup
        angular.element(document).on('shown.bs.dropdown', '.bootstrap-select.dropup', function() {
            var $select = angular.element(this);
            var $menu = $select.find('.dropdown-menu');

            // Lock the height when dropup is shown
            var currentHeight = $menu.outerHeight();
            if (currentHeight > 0) {
                $menu.css({
                    'max-height': Math.min(currentHeight, 300) + 'px',
                    'overflow-y': 'auto'
                });
                dropupHeights.set($menu[0], Math.min(currentHeight, 300) + 'px');
            }
        });

        // Additional fix: Disable scroll-triggered resize for dropup selects
        var originalSetSize = angular.element.fn.selectpicker && angular.element.fn.selectpicker.Constructor &&
                             angular.element.fn.selectpicker.Constructor.prototype.setSize;

        if (originalSetSize) {
            angular.element.fn.selectpicker.Constructor.prototype.setSize = function() {
                // Only call original setSize if not in dropup mode during scroll
                if (!this.$newElement.hasClass('dropup') || !this.$newElement.hasClass('open')) {
                    originalSetSize.apply(this, arguments);
                } else {
                    // For dropup that's already open, skip resize to prevent expansion
                    return;
                }
            };
        }
    });

})();
